import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/list-app-skeleton.tpl.svg';
import embedImgSVG from './assets/list-embed-app-skeleton.tpl.svg';

export const ListSkeleton = (): React.JSX.Element => <AppSkeletonImage src={imgSVG} />;

export const ListEmbedSkeleton = (): React.JSX.Element => <AppSkeletonImage src={embedImgSVG} />;
